<script lang="ts">
  import {createEventDispatcher, onDestroy, onMount} from 'svelte';
  import Element from './Element.svelte';
  import {filter, translate} from './Util';
  import Moveable from 'moveable';

  export let properties: any = {};

  const dispatch = createEventDispatcher();

  let element: HTMLImageElement;

  let style = '';
  let transform = '';

  let moveable: Moveable;

  $: if (properties && element) {
    style = '';
    transform = '';

    Object.entries(properties).forEach(([key, value]) => {
      if (key === 'src') return;

      if (key === 'filter') style += `filter: ${filter(value as any)};` + style;
      if (key === 'position') transform += `transform: ${translate(value as any)};`;
      if (key === 'rotation') transform += `rotate: ${value};`;

      if (key !== 'height' && key !== 'width' && key !== 'opacity') return;
      style += `${key}: ${typeof value === 'number' ? `${value}px` : value};` + style;
    });

    style += transform + style;
  }

  onMount(() => {
    const parentElement = element.parentElement;
    if (!parentElement) return {error: new Error('parent element not found'), moveable: null};

    moveable = new Moveable(parentElement, {
      target: element,
      draggable: true,
      resizable: true,
      scalable: true,
      rotatable: true,
      warpable: true,
      pinchable: true,
      origin: true,
      edge: false,
      hideDefaultLines: true,
      throttleDrag: 0,
      throttleResize: 0,
      throttleScale: 0,
      throttleRotate: 0,
      useResizeObserver: true
    });

    moveable
      .on('click', event => {
        parentElement.classList.add('show');
      })
      .on('drag', event => {
        properties.position.x = event.translate[0];
        properties.position.y = -event.translate[1];
        const transformWithoutTranslate = event.target.style.transform
          .split(';')
          .filter(filter => !filter.includes('transform'));
        transformWithoutTranslate.push(`${translate(properties.position)}`);
        event.target.style.transform = transformWithoutTranslate.join(';');
        properties = properties;
      })
      .on('dragEnd', event => {
        dispatch('propertiesUpdate', properties);
      })
      .on('resize', event => {
        if (event.width > 0) {
          properties.width = event.width;
          event.target.style.width = `${typeof properties.width === 'number' ? `${properties.width}px` : properties.width}`;
        }
        if (event.height > 0) {
          properties.height = event.height;
          event.target.style.height = `${typeof properties.height === 'number' ? `${properties.height}px` : properties.height}`;
        }
        properties = properties;
      })
      .on('resizeEnd', event => {
        dispatch('propertiesUpdate', properties);
      });
    // .on("rotate", (event) => {
    //     console.log(event, "rotate event");
    //     const rotate = event.transform.split(";").filter((filter) => filter.includes("rotate"))[0] || null;
    //     if (!rotate) return;
    //     event.target.style.transform = event.transform;
    //     properties.rotation = (rotate.split("rotate")[1] || "()").split("(")[1].split(")")[0];
    //     properties = properties;
    // })
    // .on("rotateEnd", (event) => {
    //     dispatch('propertiesUpdate', properties)
    // });
  });

  onDestroy(() => {
    moveable.destroy();
  });
</script>

<Element>
  <img bind:this={element} src={properties.src} {style} alt="img-element" />
</Element>
